import { render } from "./expertreportsview.vue?vue&type=template&id=62ac9694"
import script from "./expertreportsview.vue?vue&type=script&lang=js"
export * from "./expertreportsview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__